<template>
	<div class="pageRoot">
		<h1>TdsAppService Administration Homepage</h1>
		<p>Please select a menu item above.</p>
		<p title="Status refreshes automatically every 5 seconds">IP2Location Database Update Status: {{ip2LocationDbUpdateStatus}}</p>
		<p>IP2Location Database Update Manual Override: <button @click="manuallyTriggerIp2LocationDbUpdate">Trigger Now</button></p>
	</div>
</template>

<script>
	import { SessionCheck } from 'appRoot/scripts/Util';
	import { GetIp2LocationDbUpdateStatus, ManuallyTriggerIp2LocationDbUpdate } from 'appRoot/api/AdminMiscData';

	export default {
		components: {},
		data()
		{
			return {
				ip2LocationDbUpdateStatus: "Status Not Available",
				ip2LocationStatusUpdateInterval: null,
				ip2LocationStatusIsUpdating: false
			};
		},
		created()
		{
			SessionCheck();
			this.loadIp2LocationDbUpdateStatus();
			this.ip2LocationStatusUpdateInterval = setInterval(this.loadIp2LocationDbUpdateStatus, 5000);
		},
		beforeDestroy()
		{
			clearInterval(this.ip2LocationStatusUpdateInterval);
		},
		methods:
		{
			async loadIp2LocationDbUpdateStatus()
			{
				try
				{
					const data = await GetIp2LocationDbUpdateStatus();
					if (data.success)
						this.ip2LocationDbUpdateStatus = data.status;
					else
						this.ip2LocationDbUpdateStatus = "Error retrieving status: " + data.error;
				}
				catch (ex)
				{
					console.error(ex);
					this.ip2LocationDbUpdateStatus = "Error retrieving status: " + ex.message;
				}
			},
			async manuallyTriggerIp2LocationDbUpdate()
			{
				if (this.ip2LocationStatusIsUpdating)
					return;
				this.ip2LocationStatusIsUpdating = true;
				try
				{
					const data = await ManuallyTriggerIp2LocationDbUpdate();
					if (data.success)
					{
						alert("IP2Location database update has been manually triggered.");
					}
					else
					{
						alert("Error triggering update: " + data.error);
					}
				}
				catch (ex)
				{
					console.error(ex);
					alert("Error triggering update: " + ex.message);
				}
				finally
				{
					this.ip2LocationStatusIsUpdating = false;
				}
			}
		}
	}
</script>

<style scoped>
	.pageRoot
	{
		margin: 8px;
	}
</style>